module.exports = __webpack_public_path__ + "img/mascot-welcome.28e9edde.svg";